import { render, staticRenderFns } from "./global-loading.vue?vue&type=template&id=2b77dda0&scoped=true&"
import script from "./global-loading.vue?vue&type=script&lang=ts&"
export * from "./global-loading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b77dda0",
  null
  
)

export default component.exports